import { Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { CustomSelectCoordinatorService } from './custom-select-coordinator.service';

@Component({
  selector: 'app-custom-select',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './custom-select.component.html',
  styleUrl: './custom-select.component.scss'
})
export class CustomSelectComponent implements OnInit, OnDestroy {
  @Input() value: string = '';
  @Input() options: string[] = [];
  @Input() iconType: 'calendar' | 'graduation' | 'filter' | 'list' | 'none' = 'none';
  @Input() placeholder: string = '';
  @Input() alignLeft: boolean = false;
  @Input() fullWidth: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  isOpen: boolean = false;

  private readonly instanceId = Symbol();
  private coordinatorSubscription?: Subscription;

  constructor(
    private elementRef: ElementRef,
    private coordinator: CustomSelectCoordinatorService
  ) {}

  ngOnInit(): void {
    this.coordinatorSubscription = this.coordinator.opened$.subscribe((openedId) => {
      if (openedId !== this.instanceId) {
        this.isOpen = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.coordinatorSubscription?.unsubscribe();
  }

  toggleOpen(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.coordinator.notifyOpen(this.instanceId);
    }
  }

  selectOption(option: string, event: MouseEvent): void {
    event.stopPropagation();
    this.value = option;
    this.valueChange.emit(option);
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }
}
